// extracted by mini-css-extract-plugin
export default {"helpText":"BirthdayPreferences__helpText__d1mZX"};